import React, { useState, useImperativeHandle, forwardRef } from 'react'
import DOMPurify from "dompurify"

//images
import closeIcon from '../../../assets/images/profile/topic-info/close.png'
import playIcon from '../../../assets/images/profile/topic-info/play.png'
import questionsIcon from '../../../assets/images/profile/topic-info/questions.png'
import lawIcon from '../../../assets/images/profile/topic-info/law.png'
import askIcon from '../../../assets/images/profile/topic-info/ask.png'

function TopicInfo(props, ref) {
    const initialState = {
        topicNumber: '',
        topicName: '',
        topicPicture: '',
        topicInfo: '',
        videosDuration: '',
        questionCount: '',
    }
    const [state, setState] = useState({
        blur: false,
        popup: false,
        ...initialState
    })

    useImperativeHandle(ref, () => ({
        open: (topicNumber, topicName, topicPicture, topicInfo, videosDuration, questionCount) => handleOpen(topicNumber, topicName, topicPicture, topicInfo, videosDuration, questionCount),
        close: () => handleClose()
    }))

    const handleOpen = (topicNumber, topicName, topicPicture, topicInfo, videosDuration, questionCount) => {
        document.querySelector('body').style.overflow = 'hidden'
        document.querySelector('html').style.overflow = 'hidden'

        setState(state => ({
            ...state,
            blur: true,
            topicNumber,
            topicName,
            topicPicture,
            topicInfo,
            videosDuration,
            questionCount
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                popup: true
            }))
        }, 50)
    }

    const handleClose = () => {
        document.querySelector('body').style.overflow = 'initial'
        document.querySelector('html').style.overflow = 'initial'

        setState(state => ({
            ...state,
            popup: false
        }))
        setTimeout(() => {
            setState(state => ({
                ...state,
                blur: false,
                ...initialState
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`topic-info-overlay ${state.blur ? 'visible' : ''}`}>
            <div className={`box topic-info ${state.popup ? 'show' : ''}`}>
                <img
                    src={closeIcon}
                    className="close"
                    alt="Затваряне"
                    title="Затваряне"
                    onClick={handleClose}
                />
                <picture>
                    <img
                        src={state.topicPicture}
                        className="main-img"
                    />
                    <h2>
                        {state.topicName}
                    </h2>
                </picture>
                <span className="theme-number">
                    Тема {state.topicNumber}
                </span>
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(state.topicInfo) }} />
                <div className="bottom" style={state.topicNumber == 19 ? { justifyContent: 'space-evenly' } : {}}>
                    {state.topicNumber != 19 ?
                        <div>
                            <img src={playIcon} />
                            <h4>
                                Видео лекции:
                            <br />
                                <span>
                                    {state.videosDuration} мин.
                            </span>
                            </h4>
                        </div> : ''}
                    <div>
                        <img src={questionsIcon} />
                        <h4>
                            Изпитни въпроси:
                            <br />
                            <span>
                                {state.questionCount}
                            </span>
                        </h4>
                    </div>
                    <div>
                        <img src={lawIcon} />
                        <h4>
                            Разяснение от закона
                            <br />
                            към въпросите
                        </h4>
                    </div>
                    <div>
                        <img src={askIcon} />
                        <h4>
                            Възможност за
                            <br />
                            задаване на въпроси
                        </h4>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default forwardRef(TopicInfo)